module.exports = __webpack_public_path__ + "img/logo-white.23922587.png";